import { createFileRoute, useNavigate } from "@tanstack/react-router"
import BudgetsTab from "~/components/budget/BudgetsTab"

export const Route = createFileRoute("/_auth/budgets/_layout/$fiscalYear/_layout/")({
  component: RouteComponent,
})

function RouteComponent() {
  const { fiscalYear } = Route.useParams()
  const navigate = useNavigate()

  return (
    <BudgetsTab
      year={fiscalYear}
      onYearChange={(year) =>
        navigate({ to: "/budgets/$fiscalYear", params: { fiscalYear: year } })
      }
    />
  )
}
